module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/102/assets/images/eaeaa56f776de57eacd6c8552127893b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_filter_outline.svg
// module id = wSIX
// module chunks = 0